import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnapshotService } from '../Services/snapshot.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';

@Component({
  selector: 'app-layout-preview',
  templateUrl: './layout-preview.component.html',
  styleUrls: ['./layout-preview.component.css']
})
export class LayoutPreviewComponent implements OnInit {
  @Output() dataEvent = new EventEmitter<boolean>
  @Output() enablePreview = new EventEmitter<any>
  @Input() objectFromPreview: any;
  @Input() visualSelectedList: any;
  @Input() SnapshotType: any;
  @Input() audienceCohortType: string = '';
  maxWidgetAvailable: number = 16;
  widgetConfigured: number = 0;
  exact: number = 0;

  constructor(private _configService: SnapshotService, private _configCustomService: CustomsnapshotService) {

  }
  //---------------------------------------------------------------------
  max = this.maxWidgetAvailable;
  // exact = this.widgetConfigured; // Updated to reflect the exact value
  arr = [2, 3, 4, 6, 7];
  pages: any[] = [];
  submitEnable: boolean = false;
  layouts = [
    { label: 'Select a layout', value: null },
    {
      label: '3 Widget Layout', value: 3, url: "../../../../../assets/ImagesSnapshot/Public/threeWidget_inactive.svg",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/threeWidget_active.svg", selected: false
    }, 
    {
      label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: false
    },  
    {
      label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: false
    },
    {
      label: '7 Widget Layout', value: 7, url: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_inactive.svg",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_active.svg", selected: false
    }
  ];
  isSubmitClicked: boolean = false;

  @Output() previewEnable = new EventEmitter<any>();
  ngOnInit() {
    if(this.SnapshotType!="Single Brand"){
        // For Audience Snapshot, determine allowed layouts based on cohort type
        if(this.SnapshotType === "Audience Snapshot"){
          // Multi cohort: only 1 and 4 widget layouts
          if(this.audienceCohortType === 'multiple'){
            this.arr=[1, 2, 3, 4, 7];

          } else {
            // Single cohort: 1, 4, and 6 widget layouts
            this.arr=[1, 2, 3, 4, 6, 7];
            
          }
        } else {
          this.arr=[1, 2, 3, 4, 6, 7];
          
        }
        const newLayout = {
          label: '1 Widget Layout', value: 1, url: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_inactive.svg",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_active.svg", selected: false
        }
      this.layouts.splice(1, 0, newLayout);
    }
    this.widgetConfigured = this.visualSelectedList.length;
    this.exact = this.widgetConfigured;
    //Binding the data upon reloading
    //This block gets triggered when GET call happens
    if (this._configCustomService.dataFromPageDetail != "" && this._configService.objectFromSnapshotLayout == "") {

      this.CreatePagesForNEwWidget();
      for (let i = 0; i < this._configCustomService.dataFromPageDetail.length; i++) {
        for (let j = 0; j < this.pages.length; j++) {
          if (this._configCustomService.dataFromPageDetail[i].key == this.pages[j].page) {
            this.pages[j].selectedLayout = this._configCustomService.dataFromPageDetail[i].value;
            for (let k = 0; k < this.pages[j].layout.length; k++) {
              if (this.pages[j].selectedLayout == this.pages[j].layout[k].value) {
                this.pages[j].layout[k].selected = true;
              }
            }
          }
        }
      }
      this.HandleAddScenario();


      // for(let i=0;i<this._configCustomService.dataFromPageDetail.length;i++){
      //   this.pages.push({
      //     page: this._configCustomService.dataFromPageDetail[i].key,
      //     selectedLayout: this._configCustomService.dataFromPageDetail[i].value, // Default value will be `null`
      //     disabled: false, 
      //     dropdownOpen: false, // Add a flag to track dropdown state
      //     layout: [
      //       { label: 'Select a layout', value: null, selected: false },
      //       {
      //         label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
      //         activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: this._configCustomService.dataFromPageDetail[i].value==6?true:false
      //       },
      //       {
      //         label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
      //         activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: this._configCustomService.dataFromPageDetail[i].value==4?true:false
      //       }
      //     ],
      //   });
      // }
      // this.HandleAddScenario();

    } //This block gets triggered when new user comes
    else if (this._configService.objectFromSnapshotLayout == "" || this._configService.objectFromSnapshotLayout == undefined) {

      this.CreatePagesForNEwWidget();
      // const minInArr = Math.min(...this.arr);
      // const totalPages = Math.ceil(this.max / minInArr);
      // for (let i = 1; i <= totalPages; i++) {
      //   this.pages.push({
      //     page: `Page ${i}`,
      //     selectedLayout: null, // Default value will be `null`
      //     disabled: i !== 1, // Initially, only the first dropdown is enabled
      //     dropdownOpen: false, // Add a flag to track dropdown state
      //     layout: [
      //       { label: 'Select a layout', value: null, selected: false },
      //       {
      //         label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
      //         activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: false
      //       },
      //       {
      //         label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
      //         activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: false
      //       }
      //     ],

      //   });
      // }
      //this.HandleAddScenario();
    } //This block gets triggered when Layout submit is cicked and normally using in same session 
    else {  //when layout has been submitted (submitted data)
      this.pages = JSON.parse(this._configService.objectFromSnapshotLayout);

      this.HandleAddScenario();
      //To handle on Add sceneraio if layout widget is full n then adding more widgets
      // let selectedLayoutValue = 0;
      // let i = 0; // Make sure 'i' is initialized if it's outside the loop
      // while (i < this.pages.length && this.pages[i].disabled !== true) {
      //   selectedLayoutValue += this.pages[i].selectedLayout || 0; // Ensure selectedLayout is a number
      //   i++;
      // }
      // if (i < this.pages.length - 1 && this.widgetConfigured > selectedLayoutValue) {
      //   this.pages[i].disabled = false; // Enable the next object after the while loop
      //   this.previewEnable.emit(false);
      // }
    }

  }





  HandleAddScenario() {
    //To handle on Add sceneraio if layout widget is full n then adding more widgets
    let selectedLayoutValue = 0;
    let i = 0; // Make sure 'i' is initialized if it's outside the loop
    while (i < this.pages.length && this.pages[i].disabled !== true) {
      selectedLayoutValue += this.pages[i].selectedLayout || 0; // Ensure selectedLayout is a number
      i++;
    
    if (this.widgetConfigured > selectedLayoutValue) { //to handle add widget in visual select
      this.pages[i].disabled = false; // Enable the next object after the while loop
      this.previewEnable.emit(false);//Not using this
      if(this.pages[i].selectedLayout==undefined){
        break;
      }
    }
  }

    //To Handle delete
    if (this._configCustomService.checkDeleteClick == 1) { //if delete in visual select is being clicked then only go inside this block
      this._configCustomService.checkDeleteClick =0;
      let selectedLayoutValue2 = 0;
      let j = 0; // Make sure 'i' is initialized if it's outside the loop
      while (j < this.pages.length && this.pages[j].selectedLayout !== null) {
        selectedLayoutValue2 += this.pages[j].selectedLayout || 0; // Ensure selectedLayout is a number
        if (selectedLayoutValue2 >= this.widgetConfigured) {
          for (let k = j + 1; k < this.pages.length; k++) {
            this.pages[k].selectedLayout = null;
            this.pages[k].disabled = true;
            this.pages[k].layout = [
              { label: 'Select a layout', value: null, selected: false },
              {
                label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
                activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: false
              }
            ]
            
            // Add 6 Widget Layout based on snapshot type and cohort type
            // For Audience Snapshot with multi cohort, exclude 6 widget layout
            const shouldIncludeSixWidget = this.SnapshotType === "Audience Snapshot" 
              ? this.audienceCohortType !== 'multiple' 
              : true;
            
            if(shouldIncludeSixWidget){
              this.pages[k].layout.push({
                label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
                activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: false
              });
            }
              this.pages[k].layout.splice(3, 0, {
                label: '3 Vertical Layout',
                value: 3,
                url: "../../../../../assets/ImagesSnapshot/Public/threeWidget_inactive.svg",
                activeurl: "../../../../../assets/ImagesSnapshot/Public/threeWidget_active.svg",
                selected: false
              });
            
            this.pages[k].layout.push({
              label: '7 Widget Layout',value: 7,
              url: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_inactive.svg",
              activeurl: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_active.svg",
              selected: false
            });

            
            if(this.SnapshotType!="Single Brand"){
              const newLayout = {
                label: '1 Widget Layout', value: 1, url: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_inactive.svg",
                activeurl: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_active.svg", selected: false
              }
              this.pages[k].layout.splice(1, 0, newLayout);
            }
            this.pages[k].layout.splice(2, 0, {
              label: '2 Widget Layout', value: 2,
              url: "../../../../../assets/ImagesSnapshot/Public/twoWidget_inactive.svg",
              activeurl: "../../../../../assets/ImagesSnapshot/Public/twoWidget_active.svg",
              selected: false
            });

          }
          this.SubmitClicked();
          break;
        }
        j++;
      }
    }


    // if (i < this.pages.length - 1 && this.widgetConfigured > selectedLayoutValue) {
    //   this.pages[i].disabled = false; // Enable the next object after the while loop
    //   this.previewEnable.emit(false);
    // }
  }
  CreatePagesForNEwWidget() {
    const minInArr = Math.min(...this.arr);
    const totalPages = Math.ceil(this.max / minInArr);
    for (let i = 1; i <= totalPages; i++) {
      let Array=[
        { label: 'Select a layout', value: null, selected: false },
        {
          label: '2 Widget Layout', value: 2, url: "../../../../../assets/ImagesSnapshot/Public/twoWidget_inactive.svg",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/twoWidget_active.svg", selected: false
        },
        {
          label: '3 Widget Layout', value: 3, url: "../../../../../assets/ImagesSnapshot/Public/threeWidget_inactive.svg",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/threeWidget_active.svg", selected: false
        },
        {
          label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: false
        }
      ]
      
      // Add 6 Widget Layout based on snapshot type and cohort type
      // For Audience Snapshot with multi cohort, exclude 6 widget layout
      const shouldIncludeSixWidget = this.SnapshotType === "Audience Snapshot" 
        ? this.audienceCohortType !== 'multiple' 
        : true;
      
      if(shouldIncludeSixWidget){
        Array.push({
          label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: false
        });
      }
      
      if(this.SnapshotType!="Single Brand"){
        const newLayout =  {
          label: '1 Widget Layout', value: 1, url: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_inactive.svg",
          activeurl: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_active.svg", selected: false
        }
        Array.splice(1, 0, newLayout);
      }
      // Array.splice(2, 0, {
      //   label: '2 Widget Layout', value: 2,
      //   url: "../../../../../assets/ImagesSnapshot/Public/twoWidget_inactive.svg",
      //   activeurl: "../../../../../assets/ImagesSnapshot/Public/twoWidget_active.svg",
      //   selected: false
      // });

      Array.push({
        label: '7 Widget Layout', value: 7,
        url: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_inactive.svg",
        activeurl: "../../../../../assets/ImagesSnapshot/Public/sevenWidget_active.svg",
        selected: false
      });

      this.pages.push({
        page: `Page ${i}`,
        selectedLayout: null, // Default value will be `null`
        disabled: i !== 1, // Initially, only the first dropdown is enabled
        dropdownOpen: false, // Add a flag to track dropdown state
        layout: Array,

      });
    }
  }

  onLayoutChange(pageIndex: number, layout: any, layoutIndex: number) {

    this.pages[pageIndex].selectedLayout = layout.value;

    //check whichever layout is selected
    for (let i = 0; i < this.pages.length; i++) {
      if (i == pageIndex) {
        for (let j = 0; j < this.pages[i].layout.length; j++) {
          if (this.pages[i].layout[j].value == layout.value) {
            this.pages[i].layout[j].selected = true;
          }
          else {
            this.pages[i].layout[j].selected = false;
          }
        }
      }
    }


    //enable submit button only when layout is selected for first page
    for (let j = 0; j < this.pages[0].layout.length; j++) {
      if (this.pages[0].layout[j].selected == true) {
        this.submitEnable = true;
      }
      // else {
      //   this.submitEnable = true;
      // }
    }

    // Reset values of subsequent pages
    for (let i = pageIndex + 1; i < this.pages.length; i++) {
      this.pages[i].selectedLayout = null;
      this.pages[i].disabled = true; // Disable subsequent pages
      //Reset all the layout value for other pages
      for (let j = 0; j < this.pages[i].layout.length; j++) {
        // if(this.pages[i].layout[j].value==layout.value){
        //   this.pages[i].layout[j].selected=true;
        // }
        // else{
        this.pages[i].layout[j].selected = false;
        // 
      }
    }

    // Calculate remaining exact value after subtracting selected layout value
    let leftWidget = 0;
    // if (pageIndex === 0) {
    //   leftWidget = this.exact;
    // }
    for (let i = 0; i <= pageIndex; i++) {
      leftWidget += this.pages[i].selectedLayout || 0; // Use `0` if `selectedLayout` is `null`
    }
    const remainingExact = this.exact - leftWidget;

    // Enable next dropdown only if remainingExact is positive
    if (pageIndex < this.pages.length - 1 && remainingExact > 0) {
      this.pages[pageIndex + 1].disabled = false;
    } else if (pageIndex < this.pages.length - 1) {
      this.pages[pageIndex + 1].disabled = true;
    }

    // Close the dropdown after selecting a layout
    //this.pages[pageIndex].dropdownOpen = false;
    for (let i = 0; i < this.pages.length; i++) {
      this.pages[i].dropdownOpen = false;
    }
  }

  toggleDropdown(pageIndex: number) {
    // Toggle the dropdown state for the selected page
    this.pages[pageIndex].dropdownOpen = !this.pages[pageIndex].dropdownOpen;

    // Close other dropdown after selecting a layout
    for (let i = 0; i < this.pages.length; i++) {
      if (i != pageIndex) {
        this.pages[i].dropdownOpen = false;
      }
    }
  }

  getSelectedLayoutLabel(selectedLayout: any): string {
    if (selectedLayout === null) {
      return 'Select a layout'; // Default label when no layout is selected
    }
    // Find the layout from the available options based on snapshot type
    let availableLayouts = [
      { label: 'Select a layout', value: null },
      { label: '1 Widget Layout', value: 1 },
      { label: '2 Widget Layout', value: 2 },
      { label: '3 Widget Layout', value: 3 },
      { label: '4 Widget Layout', value: 4 },
      { label: '7 Widget Layout', value: 7 },
    ];
    
    // Add 6 Widget Layout based on snapshot type and cohort type
    // For Audience Snapshot with multi cohort, exclude 6 widget layout
    const shouldIncludeSixWidget = this.SnapshotType === "Audience Snapshot" 
      ? this.audienceCohortType !== 'multiple' 
      : true;
    
    if(shouldIncludeSixWidget) {
      availableLayouts.push({ label: '6 Widget Layout', value: 6 });
    }
    
    // Remove 1 Widget Layout for Single Brand
    if(this.SnapshotType === "Single Brand") {
      availableLayouts = availableLayouts.filter(layout => layout.value !== 1);
    }
    
    const layout = availableLayouts.find(layout => layout.value === selectedLayout);
    return layout ? layout.label : 'Select a layout';
  }
  //---------------------------------------------------------------------


  collapseLayoutPopup() {
    this.dataEvent.emit(false);
  }
  ResetClicked() {
    for (let i = 0; i < this.pages.length; i++) {
      this.pages[i].selectedLayout = null;
      this.pages[i].disabled = true; // Disable subsequent pages
      //Reset all the layout value for other pages
      for (let j = 0; j < this.pages[i].layout.length; j++) {
        // if(this.pages[i].layout[j].value==layout.value){
        //   this.pages[i].layout[j].selected=true;
        // }
        // else{
        this.pages[i].layout[j].selected = false;
        // 
      }
    }
    //Only enabling page 1:
    this.pages[0].disabled = false;
    //Disabling submit on reset click
    this.submitEnable = false;
  }

  SubmitClicked() {
    let obj = {
      bool: true,
      layoutData: JSON.stringify(this.pages)
    }
    this._configCustomService.layoutSubmitFlag = 1
    this.enablePreview.emit(obj);
    this.isSubmitClicked=true;
  }
  closeDropdowns(event: Event) {
    for (let i = 0; i < this.pages.length; i++) {
      if (this.pages[i].dropdownOpen == true) {
        this.pages[i].dropdownOpen = false;
      }
    }
    // DocumentClick (DocumentClicked)="closeDropdowns($event)"
    event.stopPropagation();
  }
}
